export const NAMESPACE = 'GROUP_STATUSES/';

export const SET_SOURCE = NAMESPACE + 'SET_SOURCE';
export const SET_WORDS_PLUS = NAMESPACE + 'SET_WORDS_PLUS';
export const SET_WORDS_MINUS = NAMESPACE + 'SET_WORDS_MINUS';
